import { useEffect, useState,useContext } from "react";
import 'react-quill/dist/quill.snow.css';
import _ from 'lodash';
import jwtDecode from "jwt-decode";
import { Drawer, Tabs, } from "antd";
import moment from "moment";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import Linkify from 'react-linkify';
import {
    MainContainer,
    ChatContainer,
    MessageList,
    Message,
    MessageSeparator,
    MessageInput,
    InputToolbox,
    AttachmentButton,
    SendButton,
    Loader,
} from "@chatscope/chat-ui-kit-react";
import { db, storage, } from "../../utils/firebase";
import fileSaver from "file-saver";
import { getSignedUrlForFile } from "../../utils/actions/userActions";
import { useNavigate } from "react-router-dom";
import { ChatRefContext } from "../../context/chatRef.context";
import { extractURLAndEncodedFilename } from "../../utils/helper";


function Chat({ open, onDrawerClose, RefId, }) {
    const loggedInUserToken = localStorage.getItem("Token")
    const navigate = useNavigate();
    if(!localStorage.getItem("Token")){
        navigate('/')
    }
    

    const {setSelectedChatRefId,selectedChatRefId} = useContext(ChatRefContext);
    const oldRefId = RefId;
    if(RefId) {
        RefId = RefId.split(' ')[0];
        if(RefId.startsWith('S')){
            RefId = RefId.slice(1)
        }
    }

   
    let loggedInUserFirstName = localStorage.getItem('firstName');
    let loggedInUserLastName = localStorage.getItem('lastName');

    // console.log('------yes----------',RefId)
    const [showAttachment, setShowAttachment,] = useState(false);
    const [progress, setProgress,] = useState(0);
    const [addingAttachment, setAddAttachment, ] = useState(false);
    const [attachments, setAttachments,] = useState([]);
    let decodedJwt =  jwtDecode(loggedInUserToken);
    
    // let { RefId } = useParams();
    // const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [messages, setMessages] = useState([]);
    const [keys, setKeys] = useState([]);
    const [isOpenedAnytime, setIsOpenedAnytime] = useState(false);

    const onClose = () => {
        // setOpen(false);
        if(RefId)
        db.ref('/users/'+ RefId+'/' + decodedJwt._id).update({
            isOnline: false,
            RefId,
            email: decodedJwt.email,
            firstName: loggedInUserFirstName || decodedJwt?.firstName,
            lastName: loggedInUserLastName || decodedJwt?.lastName,
            lastOnline: new Date().toString()
        });
        onDrawerClose();
        setSelectedChatRefId(null);
    };


    const download = async (name, url) => {
        const data=  extractURLAndEncodedFilename(url);
        let fileUrl = `${data.url}/${data.encodedFilename}`;
        fileSaver.saveAs(fileUrl, name);
      };
    

  const handlePaste = (event) => {
    event.preventDefault();
    const clipboardData = event.clipboardData || window.clipboardData;
    const pastedText = clipboardData.getData('text/plain');

    setMessage(message+pastedText);
    
    
    // Validate the pasted text to allow only plain text
    if (!isPlainText(pastedText)) {
      event.preventDefault();
      // Optionally, you can show a warning or error message to the user
      console.log('Only plain text is allowed');
    }
};

const isPlainText = (text) => {
  // You can implement additional validation here
  // For example, check for any non-text characters or patterns
  return /^[\p{L}\p{N}\p{P}\p{Z}]+$/u.test(text);
};



    const onSend = async (attachmentUrl = null,attachmentName = null) => {
        try{
            console.log('message');
            if(RefId) {
                const snapshot = await db.ref('/count/'+ RefId).get();
                let count = 0;
                if (snapshot.exists()) {
                    count = snapshot.val();
                } else {
                    count = 0;
                }
                const msgId = new Date().getTime()
                const messageObj = {
                    text:  !attachmentUrl ? message : null,
                    type: attachmentUrl ? "attachment" : "text",
                    attachmentName: attachmentName,
                    createdon: new Date().toString(),
                    userid: decodedJwt._id,
                    email: decodedJwt.email,
                    firstName: loggedInUserFirstName|| decodedJwt?.firstName,
                    lastName: loggedInUserLastName || decodedJwt?.lastName,
                    url: attachmentUrl
                }
                if(messageObj.text === '') return;
                db.ref('/messages/'+ RefId + '/' + msgId).set(messageObj)
                // .then(() => setMessages([...messages,messageObj]))
                .catch(err => console.log(err));
                db.ref('/count/'+ RefId).set(count+1);
                
                // console.log('----------3---------')
                db.ref('/users/'+ RefId + '/'+ decodedJwt._id).set({
                    msgId: msgId,
                    count: count+1,
                    isOnline: true,
                    RefId,
                    email: decodedJwt.email,
                    firstName: loggedInUserFirstName || decodedJwt?.firstName,
                    lastName: loggedInUserLastName || decodedJwt?.lastName,
                    lastOnline: new Date().toString()
                });
                db.ref("/timings/"+RefId).update({
                    lastOnline: new Date().toString(),
                    isEveryoneOffline: false,
                });
                if(!attachmentUrl){
                    setMessage("")
                }  
            }
        }
        catch(err){
            console.log("err",err)
        }
        
    }

    const onChange = (value) => {
        setMessage(value)
    }

    const handleKeySort = (arrayToSort,) =>{
        let data = [...arrayToSort].sort((a, b) => {
            return moment(a).isAfter(b) ? -1 : 1
        });
        return data;
    }

    useEffect(() => {
        if(localStorage.getItem("Token")){
        // console.log('--------a---------',open,isOpenedAnytime)
        // let openedNow = isOpenedAnytime;
        // if(open && !isOpenedAnytime) {
        //     console.log('--------b---------',open)
        //     setIsOpenedAnytime(true)
        //     openedNow = true;
        // }
        if(open && RefId) {
            // console.log('--------c---------',RefId)
                // console.log('----------1---------')
                db.ref('/users/' + RefId + '/'+ decodedJwt._id).get().then(async snapshot => {
                    db.ref('/users/' + RefId + '/'+ decodedJwt._id).onDisconnect().update({
                        isOnline: false,
                        RefId,
                        lastOnline: new Date().toString()
                    });
    
                    let value = {
                        count: 0,
                        isOnline: true,
                        RefId,
                        email: decodedJwt.email,
                        firstName: loggedInUserFirstName||decodedJwt?.firstName,
                        lastName: loggedInUserLastName || decodedJwt?.lastName,
                        lastOnline: new Date().toString()
                    };
    
                    if (snapshot.exists()) {
                        value = snapshot.val();
                    }
    
                    const snapshotVal = await db.ref('/count/'+ RefId).get();
    
                    if(snapshotVal.exists()) {
                        const count = snapshotVal.val();
                        value.count = count;
                    }
    
                    // console.log('----------2---------')
                    db.ref('/users/'+ RefId + '/' + decodedJwt._id).set({
                        ...value,
                        isOnline: true,
                        RefId,
                        email: decodedJwt.email,
                        firstName: loggedInUserFirstName || decodedJwt?.firstName,
                        lastName: loggedInUserLastName || decodedJwt?.lastName,
                        lastOnline: new Date().toString()
                    })
                    db.ref("/timings/"+RefId).update({
                        lastOnline: new Date().toString(),
                        isEveryoneOffline: false,
                    });
                });
            }
        }
    }, [open,RefId])

    useEffect(() => {
        if(localStorage.getItem("Token")){
            if(RefId) {
                db.ref('/messages/'+ RefId).on('value', (snapshot) => {
                    const data = snapshot.val();
                    let messages = [];
                    if(data)
                    messages = Object?.values(data);
        
                    const property = 'createdon';
                    const array = messages.map(mess => {
                        const date = new Date(mess.createdon);
                        return {
                            ...mess,
                            'createdon': moment(mess.createdon).format('DD-MM-YYYY'),
                            'time': date.getHours()+':'+(date.getMinutes() > 9 ? date.getMinutes() : '0'+date.getMinutes())
                        }
                    });
                    const arr = array.reduce(function (groups, item) {
                        var name = item[property]
                        var group = groups[name] || (groups[name] = []);
                        group.push(item);
                        return groups;
                    }, {});
        
                    const keys = Object.keys(arr);
                    const sortedKey = handleKeySort(keys);
                    // keys.sort();
                    setKeys(keys);
                    let localSelectedChatRefId = selectedChatRefId;
                    if(localSelectedChatRefId) {
                        localSelectedChatRefId = localSelectedChatRefId.split(' ')[0];
                        if(localSelectedChatRefId.startsWith('S')){
                            localSelectedChatRefId = localSelectedChatRefId.slice(1)
                        }
                    }
                    if(RefId==localSelectedChatRefId){
                        setMessages(arr);
                    }
                });
                }
        }  
    }, [RefId,selectedChatRefId])

    useEffect(() => {
        if(localStorage.getItem("Token")){
            if(RefId) {
                db.ref('/messages/'+ RefId).on('value', (snapshot) => {
                    const data = snapshot.val();
                    let messages = [];
                    if(data)
                    messages = Object?.values(data);
        
                    const property = 'createdon';
                    const array = messages.map(mess => {
                        const date = new Date(mess.createdon);
                        return {
                            ...mess,
                            'createdon': moment(mess.createdon).format('DD-MM-YYYY'), 
                            'time': date.getHours()+':'+(date.getMinutes() > 9 ? date.getMinutes() : '0'+date.getMinutes())
                        }
                    });
                    const arr = array.reduce(function (groups, item) {
                        var name = item[property]
                        var group = groups[name] || (groups[name] = []);
                        group.push(item);
                        return groups;
                    }, {});
        
                    const keys = Object.keys(arr);
                    const sortedKey = handleKeySort(keys);
                    // keys.sort();
                    setKeys(keys);
                    setMessages(arr);
                });
                }
        } 
    }, [])

    const uploadFiles = (file) => {
        if (!file) return;
        try{
        setAddAttachment(true);
        let fileNameForDownload = `${Date.now()}_${file.name}`;
        const uploadTask = storage.ref(`/files/${fileNameForDownload}`).put(file);
        
        uploadTask.on("state_changed", (snapshot) => {
            const prog = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            setProgress(prog);
        },
            (err) => console.log(err),
            () => {  
                    // storage.ref("files").child(file.name).getDownloadURL().then(url => {
                        onSend(fileNameForDownload,file.name)  
                        setAddAttachment(false);               
                    // }).catch(e => console.log(e))
                }
            )
        }catch(err){
            console.log('something went wrong',err)
        }
    }

    const handleFileDownload = async(fileNameForDownload,fileName) =>{
        try{
            const encodedURL = encodeURIComponent(fileNameForDownload);
            const response = await getSignedUrlForFile(encodedURL,loggedInUserToken);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); // Set the desired file name
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        }catch(err){
            console.log('eerr',err)
        }
    }

    const attachFunc = () => {
        let upload = false;
        const fileUploader = document.getElementById('file-uploader');
        fileUploader.click();
        fileUploader.addEventListener('change', (event) => {   
            if(upload === true) return;
            const files = event.target.files[0];
            uploadFiles(files);
            upload = true;
            fileUploader.value=null;
        });

    }

    const tabsChange = (key) => {
        if(key === '2') {
            setShowAttachment(true);
            let arr = [];
            keys.map(key => messages[key].filter(message => {
                if (message.type === "attachment") {
                    arr = [...arr, message];
                }
            }));
            setAttachments(arr);

        } else {
            setShowAttachment(false);
        }
    };

    const name = (message) => {
        if (message?.firstName && message?.lastName && message?.email.includes('dainsta')) {
            return message.firstName + ' ' + message.lastName + ' (Dainsta)';
        } else if (message?.firstName && message?.lastName) {
            return message.firstName + ' ' + message.lastName; 
        } else {
            return message.firstName;
        }
    };

    const items = [
        {
            key: '1',
            label: `Chat`,
            children: (keys.map((key,i) => {
                return (
                    <div key={i}>
                        <MessageSeparator content={key} />
                        {messages[key]?.map((message,j) => {
                    return (
                        <div key={j}>
                            <Message
                                model={{
                                    // message: message.text || message.attachmentName,
                                    sentTime: message.createdon,
                                    sender: message.email,
                                    position: "single",
                                    type: 'html',
                                    direction: message.userid === decodedJwt._id ? "outgoing" : "incoming"
                                }}
                            >
                                <Message.CustomContent>
                                    <Linkify componentDecorator={(decoratedHref, decoratedText, key) => <a target="_blank" rel="noopener" href={decoratedHref} key={key}>
                                        {decoratedText}
                                    </a>}>
                                    <Message.HtmlContent html={message?.text?.replaceAll('&lt;', '<')?.replaceAll('&gt;', '>') || message.attachmentName} />
                                    </Linkify>
                                </Message.CustomContent>
                                {
                                    message.type === 'attachment' && (
                                        <Message.CustomContent>
                                            <div>
                                                <p onClick={() => handleFileDownload(message.url,message.attachmentName)}  style={{cursor:'pointer',textDecoration:'underline',color:'blue'}}>{message.attachmentName}</p>
                                            </div>
                                        </Message.CustomContent>
                                    )
                                }
                            </Message>
                            {
                                message.userid === decodedJwt._id ? <div className='outgoing'>{name(message)}, {message.time}</div> : <div className='incomming' style={{margin:'-5px 0px 10px 0px'}}>{name(message)}, {message.time}</div>
                            }

                        </div>
                )
            }
            )}
                    </div>
                );
            }
            )),
        },
        {
            key: '2',
            label: `Attachments`,
            children: (attachments.length ? attachments.map((item, index) => {
                return (
                    <Message
                        model={{
                            message: item.attachmentName,
                            sentTime: item.createdon,
                            sender: item.email,
                            position: "single",
                            type: 'text',
                            direction: item.userid === decodedJwt._id ? "outgoing" : "incoming"
                        }}
                    >
                        <Message.CustomContent>
                            <div>
                                <p key={index} onClick={() => handleFileDownload(item.url,item.attachmentName)} style={{color:'blue',cursor:'pointer',textDecoration:'underline'}}>{item.attachmentName}</p>
                            </div>
                        </Message.CustomContent>
                    </Message>
                )
            }) : null),
        },
    ];

    const onKeyDown = (e) => {
        const code = (e.keyCode ? e.keyCode : e.which);
        if (code == 13 && !e.shiftKey) {
            e.preventDefault();
        }
    }

    return (
        <div>
            <Drawer
                title={"Chat Bot"}
                width={520}
                placement={"right"}
                closable={false}
                onClose={onClose}
                open={open}
                key={"right"}
            >
                <div style={{ position: "relative", height: "100%", overflow: 'hidden' }}>
                    <div
                        style={{
                            position: 'fixed',
                            top: '6px',
                            right: '8px',
                            fontSize: '18px',
                            cursor: 'pointer',
                        }}
                        onClick={onClose}
                    >X
                    </div>
                    <div
                    style={{
                        position: 'fixed',
                        top: '32px',
                        right: '28px',
                        fontSize: '16px',
                    }}
                    >
                        <span style={{
                            fontWeight: '700'
                        }}>RefId</span>
                     - {oldRefId}</div>
                    <input type="file" id='file-uploader' className='attachment-type' />
                    <MainContainer>
                        <ChatContainer>
                            <MessageList autoScrollToBottom={true} autoScrollToBottomOnMount={true}>
                                {addingAttachment && <Loader>Uploading Attachment</Loader>}
                                <Tabs tabPosition="top" defaultActiveKey="1" items={items} onChange={tabsChange} />
                            </MessageList>
                            {
                                !showAttachment && <MessageInput placeholder="Type message here" 
                                    message={message}
                                    onAttachClick={attachFunc}
                                    onChange={onChange} 
                                    value={message}
                                    onSend={(e) =>  onSend()}
                                    onPaste={handlePaste}
                                    onKeyDown={(e) => onKeyDown(e)}
                                    style={{minHeight:'120px'}}
                                    >
                                        hello
                                    </MessageInput>
                            }
                            {/* <InputToolbox style={{margin: '20px 0'}}>
                                <AttachmentButton onClick={attachFunc} style={{marginLeft: '10px'}} />
                                <ReactQuill onChange={onChange} theme="snow" value={message} />
                                <SendButton onClick={(e) => onSend()} />
                            </InputToolbox> */}
                        </ChatContainer>
                    </MainContainer>
                </div>
            </Drawer>
        </div>
    );
}

export default Chat;
